<template>
  <div class="flex min-h-72">
    <BaseCard class="flex flex-col w-full">
      <template v-if="project.cover">
        <div class="w-full aspect-ratio-16/9 relative">
          <img
            :src="project.cover"
            class="absolute w-full h-full inset-0 object-cover rounded-t-lg"
          />
        </div>
      </template>
      <template v-else>
        <div class="aspect-ratio-16/9 w-full bg-gray-200" />
      </template>

      <BaseCardBody>
        <ChannableFacebookCampaign
          v-if="entity.channableType === 'facebook_campaign'"
          :facebook-campaign="entity.channableData"
        />
        <ChannableGoogleAdsCampaign v-if="entity.gaCampaign" :ga-campaign="entity.gaCampaign" />
      </BaseCardBody>

      <BaseCardBody v-if="entity.page" class="flex-1">
        <span class="font-medium text-sm text-gray-600 capitalize"> σελιδα </span>
        <Page :page="entity.page" />
      </BaseCardBody>
    </BaseCard>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import mediableMixin from '@/mixins/mediableMixin';
import ChannableFacebookCampaign from './channelCard/ChannableFacebookCampaign.vue';
import ChannableGoogleAdsCampaign from './channelCard/ChannableGoogleAdsCampaign.vue';
import Page from './channelCard/Page.vue';

export default {
  mixins: [mediableMixin],

  components: {
    ChannableFacebookCampaign,
    ChannableGoogleAdsCampaign,
    Page,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('entities', {
      project({ projects }) {
        if (!this.entity.projectUuid) return null;

        return projects.byId[this.entity.projectUuid];
      },
    }),
  },
};
</script>
